/**
 * @file paddle Wave Summit 2020
 * @author FengGuang(fengguang01@baidu.com)
 */

import React from 'react';

import useWaveSummitHooks from './waveSummitHooks';
import A from '../../components/a/A';
import ContentPanel from './components/content-panel/ContentPanel';
import OpenSourceProjectTable from './components/open-source-project-table/OpenSourceProjectTable';
import ActiveList from './components/active-list/ActiveList';
import AwardsCeremony from './components/awards-ceremony/AwardsCeremony';


const WaveSummit: React.FC = () => {

    const {
        introduce,
        activityParticipation,
        awardsCeremony,
        openSourceProjectList,
        participationRules,
        footerText
    } = useWaveSummitHooks();

    return (
        <div className="page paddle-ws2020-page">
            <div className="paddle-ws2020-page-content">
                <div className="paddle-ws2020-banner-image" />
                <div className="paddle-ws2020-anchor-list">
                    <div>
                        <A
                            className="paddle-ws2020-anchor"
                            href="#活动简介"
                        >
                            活动简介
                        </A>
                    </div>
                    <div>
                        <A
                            className="paddle-ws2020-anchor"
                            href="#参与方式"
                        >
                            参与方式
                        </A>
                    </div>
                    <div>
                        <A
                            className="paddle-ws2020-anchor"
                            href="#颁奖仪式"
                        >
                            颁奖仪式
                        </A>
                    </div>
                    <div>
                        <A
                            className="paddle-ws2020-anchor"
                            href="#入围项目"
                        >
                            入围项目
                        </A>
                    </div>
                    <div>
                        <A
                            className="paddle-ws2020-anchor"
                            href="#详细规则"
                        >
                            详细规则
                        </A>
                    </div>
                </div>

                <ContentPanel
                    type={1}
                    titleColors="INTRODUCE"
                    title="活动简介"
                    backgroundNode={
                        <>
                            <i className="paddle-ws2020-bgicon paddle-ws2020-bgicon-1" />
                            <span id="活动简介" />
                        </>
                    }
                >
                    <div {...{dangerouslySetInnerHTML: {__html: introduce}}} />
                </ContentPanel>
                <ContentPanel
                    type={2}
                    titleColors="ACTIVITY PARTICIPATION MODE"
                    title="参与方式"
                    backgroundNode={
                        <>
                            <i className="paddle-ws2020-bgicon paddle-ws2020-bgicon-2" />
                            <span id="参与方式" />
                        </>
                    }
                >
                    <ActiveList {...activityParticipation} />
                </ContentPanel>
                <ContentPanel
                    type={3}
                    titleColors="WAVE SUMMIT+2020 AI NIGHT LIVE AWARDS CEREMONY"
                    title="WAVE SUMMIT+2020 AI之夜现场颁奖礼"
                    backgroundNode={
                        <>
                            <i className="paddle-ws2020-bgicon paddle-ws2020-bgicon-3" />
                            <span id="颁奖仪式" />
                        </>
                    }
                >
                    <AwardsCeremony {...awardsCeremony} />
                </ContentPanel>
                <ContentPanel
                    type={4}
                    titleColors="SHORTLISTED FOR OPEN SOURCE PROJECTS"
                    title="入围开源项目"
                    subTitle="项目序号由入围先后顺序决定"
                    backgroundNode={
                        <>
                            <i className="paddle-ws2020-bgicon paddle-ws2020-bgicon-4" />
                            <span id="入围项目" />
                        </>
                    }
                >
                    <OpenSourceProjectTable list={openSourceProjectList} />
                </ContentPanel>
                <ContentPanel
                    type={1}
                    titleColors="PARTICIPATION RULES"
                    title="参与规则"
                    backgroundNode={
                        <>
                            <i className="paddle-ws2020-bgicon paddle-ws2020-bgicon-5" />
                            <span id="详细规则" />
                        </>
                    }
                >
                    <i className="paddle-ws2020-bgicon paddle-ws2020-bgicon-6" />
                    <div
                        className="paddle-ws2020-participation-rules"
                        {...{dangerouslySetInnerHTML: {__html: participationRules}}}
                    />
                </ContentPanel>
                <div
                    className="paddle-ws2020-footer-text"
                    {...{dangerouslySetInnerHTML: {__html: footerText}}}
                />
                <div className="paddle-ws2020-bgicon paddle-ws2020-bgicon-7">
                </div>
            </div>
        </div>
    );
};

export default React.memo(WaveSummit);
